export default __webpack_public_path__ + "static/international-yards-mobile-a7fee9ba7860a5681e9853d1d94a6960.svg";